export const INSURERS = [
  "Seguros Comerciales Bolívar / El Libertador",
  "Fianzacrédito",
  "Unifianza",
  "AFFI",
  "Afianzadora Nacional (Afiansa)",
  "Suramericana (SURA)",
  "Zurich Colombia Seguros",
  "Seguros Mundial",
  "Fianly",
  "Fianzas de Colombia",
  "Fianza Profesional",
  "Apriori Legal",
  "Fianza Inmobiliaria de Bogotá",
  "Afiancol",
  "Seguros Emporio",
  "Afianzados VT",
  "Fincar Ltda",
  "Protecsa",
  "Royal",
  "Otra",
] as const;
